export async function injectHtml(container, html, delay = 0) {
    return await injectHtmlIntoEntity($(container), html, delay);
}

export async function injectHtmlIntoEntity(containerEntity, html, delay = 0) {
    try {
        // Inject HTML into DOM.
        containerEntity.html(html);

        if (delay) {
            // Wait x number of milliseconds. We might not need to do this, as I understand it the request to add html to the DOM
            // will be added to the callstack in JavaScript, this will be processed and the HTML injected into the dom before the next 
            // request in the callstack (to bind events to the injected html) is process.
            const promise = new Promise((resolve, reject) => {
                setTimeout(() => resolve(true), delay);
            });
            await promise;
        }

        return true;
    }
    catch (ex) {
        console.error(ex);
        return false;
    }
}